import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { TasksOnMyResponsibilityPage } from "src/components/views/tasks/pages/TasksOnMyResponsibilityPage.tsx";

export const Route = createFileRoute("/_authenticated/_shell/tasks/onMyResponsibility")({
	staticData: { title: i18n.t("on_my_responsibility"), legacyViewKey: "tasksOnMyResponsibilityPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <TasksOnMyResponsibilityPage />;
}
